var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M28.775 9.6a3.37 3.37 0 0 0-2.351-2.424C24.339 6.666 16 6.666 16 6.666s-8.34 0-10.424.558a3.37 3.37 0 0 0-2.351 2.424 35 35 0 0 0-.558 6.412 35 35 0 0 0 .558 6.46 3.37 3.37 0 0 0 2.351 2.328c2.085.557 10.424.557 10.424.557s8.339 0 10.424-.557a3.37 3.37 0 0 0 2.35-2.424c.38-2.1.566-4.23.558-6.364a35 35 0 0 0-.557-6.46"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M13 12.62c0-.636 0-.954.133-1.132a.67.67 0 0 1 .486-.265c.221-.016.489.156 1.024.5l5.257 3.38c.465.298.697.448.777.638.07.165.07.353 0 .519-.08.19-.312.339-.777.637l-5.257 3.38c-.535.344-.803.516-1.024.5a.67.67 0 0 1-.486-.265C13 20.334 13 20.016 13 19.38z"
  })));
};
export default SvgYoutube;